import { EmptyState as RdsEmptyState, Icon, type LucideIconName } from "@/deps/ui-library";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * Empty states say what will appear, not that nothing is here (RDS voice).
 *
 * RDS `EmptyState`, on a card surface of its own: it stands alone on a screen. `bare` drops the
 * surface for a place that already has one — the body of a table, a titled card.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  bare = false,
}: {
  icon: LucideIconName;
  title: string;
  description: string;
  action?: ReactNode;
  bare?: boolean;
}) {
  return (
    <RdsEmptyState
      icon={<Icon name={icon} size="md" />}
      title={title}
      description={description}
      config={{ size: "sm", variant: "primary" }}
      className={cn(!bare && "bg-card border-border rounded-lg border px-6")}
    >
      {action}
    </RdsEmptyState>
  );
}
